"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _default = exports.default = _styledComponents.default.span.withConfig({
  componentId: "sc-uahlr9-0"
})(["display:block;width:24px;height:24px;margin-left:16px;div{width:20px;height:3px;background-color:#000000;border-radius:20px;&:first-child{margin-bottom:4px;margin-top:4px}&:last-child{margin-top:4px;}}@media ", "{display:none;}"], _responsive.default.lg);